<template>
    <list v-if="invoiceStore.type == 1"></list>
    <create v-else-if="invoiceStore.type == 2"></create>
    <preview v-else-if="invoiceStore.type == 3"></preview>
    <edit v-else-if="invoiceStore.type == 4"></edit>
    <debt-collector-form />
</template>

<script>
    import { useInvoiceStore } from '../../stores/InvoiceStore.js'
    import debtCollectorForm from '../DebtCollectorFormComponent'
    import list from './ListComponent'
    import create from './CreateComponent'
    import preview from './PreviewComponent'
    import edit from './EditComponent'
    export default {
        props: {
            invoice: {
                type: [Array, Object]
            }
        },
        components: {
            debtCollectorForm,
            list,
            create,
            preview,
            edit
        },
        mounted() {
        },
        setup(props) {
            useInvoiceStore().invoice = props.invoice;
            return {
                invoiceStore: useInvoiceStore()
            }
        }
    }
</script>
